/* eslint-disable camelcase */
/**
 * 研究院小模型对接API
 */
export default {

    /**
     * OCR识别
     */
    async img2text_ocr (content) {
        let API_URL = '/models';
        let speech2textApi = API_URL + '/img2text_ocr';
        let task_id = 5;
        let mode = 1; // 1: 默认处理base64
        if (content.indexOf('http:') === 0 || content.indexOf('https:') === 0 || content.indexOf('/') === 0) mode = 2; // 2: 处理URL
        if (content.indexOf('data:') === 0) content = content.substring(content.indexOf(',') + 1); // 截取base64
        let payload = { task_id, mode, content };
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);

        let resp = await fetch(speech2textApi, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`模型执行失败[${resp.status}]:${resp.statusText}`);
        } else {
            let json = await resp.json();
            return json.result || '';
        }
    },

    /**
     * 人群密度估计
     */
    async img2text_person_counting (content) {
        let API_URL = '/models';
        let speech2textApi = API_URL + '/img2text_person_counting';
        let task_id = 3;
        let mode = 1; // 1: 默认处理base64
        if (content.indexOf('http:') === 0 || content.indexOf('https:') === 0 || content.indexOf('/') === 0) mode = 2; // 2: 处理URL
        if (content.indexOf('data:') === 0) content = content.substring(content.indexOf(',') + 1); // 截取base64
        let payload = { task_id, mode, content };
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);

        let resp = await fetch(speech2textApi, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`模型执行失败[${resp.status}]:${resp.statusText}`);
        } else {
            let json = await resp.json();
            let content = json.describe;
            return content;
        }
    },

    /**
     * 车辆统计
     */
    async img2text_vehicles_counting (content) {
        let API_URL = '/models';
        let speech2textApi = API_URL + '/img2text_vehicles_counting';
        let task_id = 4;
        let mode = 1; // 1: 默认处理base64
        if (content.indexOf('http:') === 0 || content.indexOf('https:') === 0 || content.indexOf('/') === 0) mode = 2; // 2: 处理URL
        if (content.indexOf('data:') === 0) content = content.substring(content.indexOf(',') + 1); // 截取base64
        let payload = { task_id, mode, content };
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);

        let resp = await fetch(speech2textApi, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`模型执行失败[${resp.status}]:${resp.statusText}`);
        } else {
            let json = await resp.json();
            let content = json.describe;
            return content;
        }
    },

    /**
     * 对图片内容可实现 “火焰烟雾检测”、“坐轮椅的乘客检测”、“跌倒的乘客检测”、“站内积水检测”四种功能事件的工具。
     */
    async img2text_glip (url, image, content, task_type) {
        let API_URL = '/models';
        let speech2textApi = API_URL + '/img2text_glip';
        let task_id = 8;
        let image_url = url;
        let image_base64 = null;
        // if (image.indexOf('http:') === 0 || image.indexOf('https:') === 0 || image.indexOf('/') === 0) image_url = image; // 2: 处理URL
        if (image.indexOf('data:') === 0) image_base64 = image.substring(image.indexOf(',') + 1); // 截取base64
        let payload = { task_id, task_type, content };
        if (image_url)payload.image_url = image_url;
        if (image_base64)payload.image_base64 = image_base64;
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);

        let resp = await fetch(speech2textApi, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`模型执行失败[${resp.status}]:${resp.statusText}`);
        } else {
            let json = await resp.json();
            let data = json.data;
            let content = json.event_label;
            return { data, content };
        }
    },

    /**
     * 文生图
     */
    async text2image_sd (content) {
        let API_URL = '/models';
        let speech2textApi = API_URL + '/text2image_sd';
        let task_id = 7;
        let payload = { task_id, content };
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);

        let resp = await fetch(speech2textApi, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`模型执行失败[${resp.status}]:${resp.statusText}`);
        } else {
            // 语音转文字结果
            let json = await resp.json();
            return json.data;
        }
    },

    /**
     * 语音转文字
     */
    async speech2text (content) {
        let API_URL = '/models';
        let speech2textApi = API_URL + '/speech2text';
        let mode = 1;
        let task_id = 1;
        let payload = { task_id, mode, content };
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);

        let resp = await fetch(speech2textApi, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`语音转文字失败[${resp.status}]:${resp.statusText}`);
        } else {
            // 语音转文字结果
            let json = await resp.json();
            let content = json.result || '';
            return content;
        }
    },

    /**
     * 文字转语音
     */
    async text2speech (content) {
        let API_URL = '/models';
        let text2speechApi = API_URL + '/text2speech';
        let task_id = 2;
        let payload = { task_id, content };
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);

        let resp = await fetch(text2speechApi, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`文字转语音失败[${resp.status}]:${resp.statusText}`);
        } else {
            // 语音转文字结果
            let json = await resp.json();
            let base64String = json.result || '';
            return base64String;
        }
    }
};
